import $ from "jquery";
// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------
var number = /^[0-9]{0,20}$/;
var check_email =
  /^([a-zA-Z0-9_\.\+\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
var epath = /[(\*\(\)\[\]\,\/\@\?\:\;\'\"\`\~\\#\$\%\^\&\<\>)+]/;
var checkPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d#$@!%&*?]{8,20}$/;

var define = {
  error_email_null: "メールアドレスを入力してください",
  login_email_null: "メールアドレスまたはパスワードは違っています。",
  error_email_charactor: "メールアドレスは特殊文字を入力できません",
  error_email_error: "メールアドレスまたはパスワードは違っています。",

  error_pass_null: "パスワードを入力してください",
  login_pass_null: "メールアドレスまたはパスワードは違っています。",
  error_pass_than: "メールアドレスまたはパスワードは違っています。",
  error_pass_check: "メールアドレスまたはパスワードは違っています。",

  error_typeuse_null: "エキスパートタイプを選択してください。",

  error_confirm_password_null: "パスワード（確認用）を入力してください",
  error_password_than: "パスワードは、8文字以上にしてください。",
  error_password_check: "パスワードは正しく入力されていません。",

  message_done: "パスワードを成功に再設定しました。"
};
$(document).ready(function () {
  // Expert Signup
  $("body").on("submit", "#frmInvite", function (prevent) {
    prevent.preventDefault();
    let id = document.getElementById("id").value;
    let first_name = document.getElementById("first_name").value;
    let last_name = document.getElementById("last_name").value;
    let email = document.getElementById("email").value;
    let role = document.getElementById("role").value;
    let url = $("#frmInvite").attr("action");
    let _token = $('meta[name="csrf-token"]').attr("content");
    var request = $.ajax({
      url: url,
      data: {
        id: id,
        first_name: first_name,
        last_name: last_name,
        email: email,
        role: role,
        _token: _token,
      },
      type: "POST",
      dataType: "json",
      beforeSend: function () {
        $("#btnFrmInvite").attr("disabled", "disabled");
      },
    });
    request.done(function (data) {
      $('#textHeader').html("招待する方のメールアドレスへ<br/>登録案内のメールをお送りました。");
      $("#btnFrmInvite").removeAttr("disabled");
      $("#frmInviteDone").css( "display", "block" );
      $("#divForm").css( "display", "none" );
      $('#dataInviteInit').html(data.html_data);
    });
    request.fail(function (jqXHR, textStatus) {
      if(jqXHR.responseJSON == undefined) {
        location.reload();
      } else {
        $("#btnFrmInvite").removeAttr("disabled");
        let fail = jqXHR.responseJSON.message;
        let first_name = fail.first_name != undefined ? fail.first_name[0] : "";
        let last_name = fail.last_name != undefined ? fail.last_name[0] : "";
        let email = fail.email != undefined ? fail.email[0] : "";
        let role = fail.role != undefined ? fail.role[0] : "";
        $(".first_name").addClass("show").text(first_name);
        $(".last_name").addClass("show").text(last_name);
        $(".email").addClass("show").text(email);
        $(".role").addClass("show").text(role);
      }
    });

    return request;
  });

  // Expert Signup
  $("body").on("submit", "#signupForm", function (prevent) {
    prevent.preventDefault();
    let sigemail = document.getElementById("signupEmail").value;
    let sigtypeuse = '';
    let selected = $(
        "input[type=radio][name=signupTypeUse]:checked"
    );
    if (selected.length > 0) {
        sigtypeuse = selected.attr('value');
    }
    let sigerror = {
      errorEmail: function (message) {
        $("#signupEmail").addClass("error");
        $(".errorSignupEmail").addClass("show").text(message);
      },
      hideEmail: function () {
        $("#signupEmail").removeClass("error");
        $(".errorSignupEmail").removeClass("show");
      },
      errorTypeUse: function (message) {
        $("#signupTypeUse").addClass("error");
        $(".errorTypeUse").addClass("show").text(message);
      },
      hideTypeUse: function () {
        $("#signupTypeUse").removeClass("error");
        $(".errorTypeUse").removeClass("show");
      },
    };
    if (sigemail != "" && sigtypeuse != "") {
      let url = $("#signupForm").attr("action");
      let _token = $('meta[name="csrf-token"]').attr("content");
      var request = $.ajax({
        url: url,
        data: {
          email: sigemail,
          typeuse: sigtypeuse,
          _token: _token,
        },
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#signupForm .btnRegister").attr("disabled", "disabled");
        },
      });
      request.done(function (data) {
        if(data.status_code == 419) {
          alert('ページをリロードしてください。');
          location.reload();
        } else {
          $("#signupForm .btnRegister").removeAttr("disabled");
          $("#frmDone").css( "display", "block" );
          $("#frmForm").css( "display", "none" );
        }
      });
      request.fail(function (jqXHR, textStatus) {
        $("#signupForm .btnRegister").removeAttr("disabled");
        let fail = jqXHR.responseJSON.message;
        let email = fail.email != undefined ? fail.email[0] : "";
        let typeuse = fail.typeuse != undefined ? fail.typeuse[0] : "";
        sigerror.errorEmail(email);
        sigerror.errorTypeUse(typeuse);
      });

      return request;
    } else if (sigemail == "" && sigtypeuse == "") {
      sigerror.errorEmail(define.error_email_null);
      sigerror.errorTypeUse(define.error_typeuse_null);
    } else if (sigemail != "" || sigtypeuse != "") {
      if (sigemail != "") {
        sigerror.hideEmail();
      } else {
        sigerror.errorEmail(define.error_email_null);
      }
      if (sigtypeuse != "") {
        sigerror.hideTypeUse();
      } else {
        sigerror.errorTypeUse(define.error_typeuse_null);
      }
    }

    return false;
  });
  // Expert Login
  $("body").on("submit", "#loginForm", function (e) {
    e.preventDefault();
    let error = {
      errorEmail: function (message) {
        $("#loginEmail").addClass("error");
        let mess = message != undefined ? message.join(' ') : '';
        $(".errorLoginEmail").addClass("show").text(mess);
      },
      hideEmail: function () {
        $("#loginEmail").removeClass("error");
        $(".errorLoginEmail").removeClass("show");
      },
      errorPassword: function (message) {
        $("#loginPassword").addClass("error");
        let mess = message != undefined ? message.join(' ') : '';
        $(".errorLoginPassword").addClass("show").text(mess);
      },
      hidePassword: function () {
        $("#loginPassword").removeClass("error");
        $(".errorLoginPassword").removeClass("show");
      },
      // hideAgeCheck: function () {
      //   $(".errorViolateCheck").removeClass("show").text('');
      // },
      // errorAgeCheck: function (message) {
      //   $(".errorViolateCheck").addClass("show").text(message);
      // },
      hideVioldateCheck: function () {
        $(".errorViolateCheck").removeClass("show").text('');
      },
      errorVioldateCheck: function (message) {
        $(".errorViolateCheck").addClass("show").text(message);
      }
    };
    let email = document.getElementById("loginEmail").value;
    let password = document.getElementById("loginPassword").value;
    if (email != "" && password != "") {
      error.hideEmail();
      error.hidePassword();
      error.hideVioldateCheck();
      let url = $("#loginForm").attr("action");
      let _token = $('meta[name="csrf-token"]').attr("content");
      let data = {
        email: email,
        password: password,
        _token: _token,
      };
      var request = $.ajax({
        url: url,
        data: data,
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#loginForm .btnSign").attr("disabled", "disabled");
        },
      });

      request.done(function (data) {
        if (data.status == false && data.status_code == 419) {
          alert('ページをリロードしてください。');
          location.reload();
          // Process relogin when Your session token expired due to inactivity
          // let _data = {
          //   email: email,
          //   password: password,
          //   _token: data.csrf_token,
          // };
          // var _request = $.ajax({
          //   url: url,
          //   data: _data,
          //   type: "POST",
          //   dataType: "json",
          //   beforeSend: function () {
          //     $("#loginForm .btnSign").attr("disabled", "disabled");
          //   },
          // });
          // _request.done(function (item) {
          //   window.location.href = item.redirect;
          // });
          // _request.fail(function (jqXHR, textStatus) {
          //   $("#loginForm .btnSign").removeAttr("disabled");
          //   let fail = jqXHR.responseJSON.message;
          //   let email = fail.email != undefined ? fail.email : fail.password;
          //   let password = fail.password != undefined ? fail.password : fail.email;
          //   let age_check = fail.age_check != undefined ? fail.age_check : fail.age_check;
          //   error.errorEmail(email);
          //   error.errorPassword(password);
          //   error.errorVioldateCheck(age_check);
          // });
          // return _request;
        } else {
          window.location.href = data.redirect;
        }
      });

      request.fail(function (jqXHR, textStatus) {
        $("#loginForm .btnSign").removeAttr("disabled");
        let fail = jqXHR.responseJSON.message;
        let email = fail.email != undefined ? fail.email : fail.password;
        let password = fail.password != undefined ? fail.password : fail.email;
        let violate_check = fail.violate_check != undefined ? fail.violate_check : fail.violate_check;
        error.errorEmail(email);
        error.errorPassword(password);
        error.errorVioldateCheck(violate_check);
      });

      return request;
    } else if (email == "" && password == "") {
      error.errorEmail(define.login_email_null);
      error.errorPassword(define.login_pass_null);
    } else if (email != "" || password != "") {
      if (email != "") {
        if (!email.match(check_email)) {
          error.errorEmail(define.error_email_error);
        } else {
          error.hideEmail();
        }
      } else {
        error.errorEmail(define.error_email_null);
      }

      if (password != "") {
        if (password.length < 8) {
          error.errorPassword(define.error_pass_than);
        } else if (!checkPassword.test(password)) {
          error.errorPassword(define.error_pass_check);
        } else {
          error.hidePassword();
        }
      } else {
        error.errorPassword(define.error_pass_null);
      }
    }

    return false;
  });

  // Expert Password Reset
  $("body").on("submit", "#frmExpertPasswordReset", function (prevent) {
    prevent.preventDefault();
    let email = document.getElementById("email").value;
    let sigerror = {
      errorEmail: function (message) {
        $(".errorTxt2").show().text(message);
      },
      hideEmail: function () {
        $(".errorTxt2").hide();
      },
    };
    if (email != "" ) {
      let url = $("#frmExpertPasswordReset").attr("action");
      let _token = $('input[name="_token"]').val();
      var request = $.ajax({
        url: url,
        data: {
          email: email,
          _token: _token,
        },
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#frmExpertPasswordReset .btnSign02").attr("disabled", "disabled");
        },
      });
      request.done(function (data) {
        $("#frmExpertPasswordReset .btnSign02").removeAttr("disabled");
        if (data.status == "error") {
          let email = data.message.email != undefined ? data.message.email[0] : "";
          sigerror.errorEmail(email);
        } else {
          window.location.href = data.redirect;
        }
      });

      return request;
    } else if (email == "") {
      sigerror.errorEmail(define.error_email_null);
    }

    return false;
  });

  // Expert Change Password Reset
  $("body").on("submit", "#frmExpertChangePasswordReset", function (prevent) {
    prevent.preventDefault();
    let password = document.getElementById("password").value;
    let confirm_password = document.getElementById("confirm_password").value;
    let sigerror = {
      errorPassword: function (message) {
        $(".password").show().text(message);
      },
      hidePassword: function () {
        $(".password").hide();
      },
      errorConfirmPassword: function (message) {
        $(".confirm_password").show().text(message);
      },
      hideConfirmPassword: function () {
        $(".confirm_password").hide();
      },
    };
    if (password != "" && confirm_password != "") {
      let url = $("#frmExpertChangePasswordReset").attr("action");
      let _token = $('input[name="_token"]').val();
      var request = $.ajax({
        url: url,
        data: {
          active: $('input[name="active"]').val(),
          is_active: $('input[name="is_active"]').val(),
          id: $('input[name="id"]').val(),
          password: password,
          confirm_password: confirm_password,
          _token: _token,
        },
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#frmExpertChangePasswordReset .btnSign02").attr("disabled", "disabled");
        },
      });
      request.done(function (data) {
        $("#frmExpertChangePasswordReset .btnSign02").removeAttr("disabled");
        if (data.status == "error") {
          sigerror.hidePassword();
          sigerror.hideConfirmPassword();
          let password = data.message.password != undefined ? data.message.password[0] : "";
          let confirm_password = data.message.confirm_password != undefined ? data.message.confirm_password[0] : "";
          if(password) {
            sigerror.errorPassword(password);
          }
          if(confirm_password) {
            sigerror.errorConfirmPassword(confirm_password);
          }
        } else {
          alert(define.message_done);
          window.location.href = data.redirect;
        }
      });

      return request;

    } else if (password == "" && confirm_password == "") {
      sigerror.errorPassword(define.error_pass_null);
      sigerror.errorConfirmPassword(define.error_confirm_password_null);
    } else if (password != "" || confirm_password != "") {
      if (password != "") {
        if (password.length < 8) {
          sigerror.errorPassword(define.error_password_than);
        } else if (!checkPassword.test(password)) {
          sigerror.errorPassword(define.error_password_check);
        } else {
          sigerror.hidePassword();
        }
      } else {
        sigerror.errorPassword(define.error_pass_null);
      }

      if (confirm_password != "") {
        if (confirm_password.length < 8) {
          sigerror.errorConfirmPassword(define.error_password_than);
        } else if (!checkPassword.test(password)) {
          sigerror.errorConfirmPassword(define.error_password_check);
        } else {
          sigerror.hideConfirmPassword();
        }
      } else {
        sigerror.errorConfirmPassword(define.error_confirm_password_null);
      }
    }

    return false;
  });

  // Oder Password Reset
  $("body").on("submit", "#frmOrderPasswordReset", function (prevent) {
    prevent.preventDefault();
    let email = document.getElementById("email").value;
    let sigerror = {
      errorEmail: function (message) {
        $(".errorTxt2").show().text(message);
      },
      hideEmail: function () {
        $(".errorTxt2").hide();
      },
    };
    if (email != "" ) {
      let url = $("#frmOrderPasswordReset").attr("action");
      let _token = $('input[name="_token"]').val();
      var request = $.ajax({
        url: url,
        data: {
          email: email,
          _token: _token,
        },
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#frmOrderPasswordReset .btnSign02").attr("disabled", "disabled");
        },
      });
      request.done(function (data) {
        $("#frmOrderPasswordReset .btnSign02").removeAttr("disabled");
        if (data.status == "error") {
          let email = data.message.email != undefined ? data.message.email[0] : "";
          sigerror.errorEmail(email);
        } else {
          window.location.href = data.redirect;
        }
      });

      return request;
    } else if (email == "") {
      sigerror.errorEmail(define.error_email_null);
    }

    return false;
  });

  // Expert Change Password Reset
  $("body").on("submit", "#frmOrderChangePasswordReset", function (prevent) {
    prevent.preventDefault();
    let password = document.getElementById("password").value;
    let confirm_password = document.getElementById("confirm_password").value;
    let sigerror = {
      errorPassword: function (message) {
        $(".password").show().text(message);
      },
      hidePassword: function () {
        $(".password").hide();
      },
      errorConfirmPassword: function (message) {
        $(".confirm_password").show().text(message);
      },
      hideConfirmPassword: function () {
        $(".confirm_password").hide();
      },
    };
    if (password != "" && confirm_password != "") {
      let url = $("#frmOrderChangePasswordReset").attr("action");
      let _token = $('input[name="_token"]').val();
      var request = $.ajax({
        url: url,
        data: {
          active: $('input[name="active"]').val(),
          is_active: $('input[name="is_active"]').val(),
          id: $('input[name="id"]').val(),
          password: password,
          confirm_password: confirm_password,
          _token: _token,
        },
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#frmOrderChangePasswordReset .btnSign02").attr("disabled", "disabled");
        },
      });
      request.done(function (data) {
        $("#frmOrderChangePasswordReset .btnSign02").removeAttr("disabled");
        if (data.status == "error") {
          sigerror.hidePassword();
          sigerror.hideConfirmPassword();
          let password = data.message.password != undefined ? data.message.password[0] : "";
          let confirm_password = data.message.confirm_password != undefined ? data.message.confirm_password[0] : "";
          if(password) {
            sigerror.errorPassword(password);
          }
          if(confirm_password) {
            sigerror.errorConfirmPassword(confirm_password);
          }
        } else {
          alert(define.message_done);
          window.location.href = data.redirect;
        }
      });

      return request;

    } else if (password == "" && confirm_password == "") {
      sigerror.errorPassword(define.error_pass_null);
      sigerror.errorConfirmPassword(define.error_confirm_password_null);
    } else if (password != "" || confirm_password != "") {
      if (password != "") {
        if (password.length < 8) {
          sigerror.errorPassword(define.error_password_than);
        } else if (!checkPassword.test(password)) {
          sigerror.errorPassword(define.error_password_check);
        } else {
          sigerror.hidePassword();
        }
      } else {
        sigerror.errorPassword(define.error_pass_null);
      }

      if (confirm_password != "") {
        if (confirm_password.length < 8) {
          sigerror.errorConfirmPassword(define.error_password_than);
        } else if (!checkPassword.test(password)) {
          sigerror.errorConfirmPassword(define.error_password_check);
        } else {
          sigerror.hideConfirmPassword();
        }
      } else {
        sigerror.errorConfirmPassword(define.error_confirm_password_null);
      }
    }

    return false;
  });

  // Expert Login
  $("body").on("submit", "#loginOrder", function (e) {
    e.preventDefault();
    let error = {
      errorEmail: function (message) {
        $("#loginOrderEmail").addClass("error");
        let mess = message != undefined ? message.join(' ') : '';
        $(".errorloginOrderEmail").addClass("show").text(mess);
      },
      hideEmail: function () {
        $("#loginOrderEmail").removeClass("error");
        $(".errorloginOrderEmail").removeClass("show");
      },
      errorPassword: function (message) {
        $("#loginOrderPassword").addClass("error");
        let mess = message != undefined ? message.join(' ') : '';
        $(".errorLoginOrderPassword").addClass("show").text(mess);
      },
      hidePassword: function () {
        $("#loginOrderPassword").removeClass("error");
        $(".errorLoginOrderPassword").removeClass("show");
      },
    };
    let email = document.getElementById("loginOrderEmail").value;
    let password = document.getElementById("loginOrderPassword").value;
    if (email != "" && password != "") {
      error.hideEmail();
      error.hidePassword();
      let url = $("#loginOrder").attr("action");
      let _token = $('meta[name="csrf-token"]').attr("content");
      let data = {
        email: email,
        password: password,
        _token: _token,
      };
      var request = $.ajax({
        url: url,
        data: data,
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          $("#loginOrder .btnSign").attr("disabled", "disabled");
        },
      });

      request.done(function (data) {
        if (data.status == false && data.status_code == 419) {
          // Process relogin when Your session token expired due to inactivity
          alert('ページをリロードしてください。');
          location.reload();
          // let _data = {
          //   email: email,
          //   password: password,
          //   _token: data.csrf_token,
          // };
          // var _request = $.ajax({
          //   url: url,
          //   data: _data,
          //   type: "POST",
          //   dataType: "json",
          //   beforeSend: function () {
          //     $("#loginOrder .btnSign").attr("disabled", "disabled");
          //   },
          // });
          // _request.done(function (item) {
          //   window.location.href = item.redirect;
          // });
          // _request.fail(function (jqXHR, textStatus) {
          //   $("#loginOrder .btnSign").removeAttr("disabled");
          //   let fail = jqXHR.responseJSON.message;
          //   let email = fail.email != undefined ? fail.email : fail.password;
          //   let password =
          //     fail.password != undefined ? fail.password : fail.email;
          //   error.errorEmail(email);
          //   error.errorPassword(password);
          // });
          // return _request;
        } else {
          window.location.href = data.redirect;
        }
      });

      request.fail(function (jqXHR, textStatus) {
        $("#loginOrder .btnSign").removeAttr("disabled");
        let fail = jqXHR.responseJSON.message;
        let email = fail.email != undefined ? fail.email : fail.password;
        let password = fail.password != undefined ? fail.password : fail.email;
        error.errorEmail(email);
        error.errorPassword(password);
      });

      return request;
    } else if (email == "" && password == "") {
      error.errorEmail(define.login_email_null);
      error.errorPassword(define.login_pass_null);
    } else if (email != "" || password != "") {
      if (email != "") {
        if (!email.match(check_email)) {
          error.errorEmail(define.error_email_error);
        } else {
          error.hideEmail();
        }
      } else {
        error.errorEmail(define.error_email_null);
      }

      if (password != "") {
        if (password.length < 8) {
          error.errorPassword(define.error_pass_than);
        } else if (!checkPassword.test(password)) {
          error.errorPassword(define.error_pass_check);
        } else {
          error.hidePassword();
        }
      } else {
        error.errorPassword(define.error_pass_null);
      }
    }

    return false;
  });

  $(document).on('change', "input[name='price_quote']", function(e) {
    e.preventDefault();
    let value = $(this).val();
    if (value == 2) {
      $("input[name='contract_type']").prop('checked', false);
      $("input[name='contract_amount'").val('');
    }
  });
});

function handleAddFormChildId() {
  const btnAddEle = document.getElementById("jsBtnAddChildId");
  const boxEle = document.getElementById("jsBoxAddChildId");
  let num = 0;
  if (btnAddEle && boxEle) {
    btnAddEle.addEventListener("click", function () {
      const blockChildId = `
        <div class="twoBox3 custom">
          <div class="blockBox">
              <div class="box">
                  <div>
                      <input type="text" id="child_id_${num}" name="child_id_${num}" value="" placeholder="子ID">
                      <p class="textError child_id_${num}">子IDを入力してください。</p>
                  </div>
              </div>
          </div>
          <div class="blockBtn">
              <span class="btnDelPlus jsBtnDeleteChild"></span>
          </div>
        </div>
      `;
      num += 1;
      boxEle.insertAdjacentHTML("beforeend", blockChildId);
      handleDelFormChildId();
    });
  }
}

function handleDelFormChildId() {
  const btnDels = document.querySelectorAll(".jsBtnDeleteChild");
  if (btnDels) {
    btnDels.forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.closest(".twoBox3").remove();
      });
    });
  }
}

function handleUpdateInputNameChildIdExpert(elements) {
  if(elements){
    elements.forEach((element, index) => {
      element.querySelector('input[type=text]').setAttribute('name', `company_name_corporate[${index + 1}]`);
    })
  }
}

function handleAddFormChildIdExpert() {
  const btnAddEle = document.getElementById("jsBtnAddChildIdExport");
  const boxEle = document.getElementById("jsBoxAddChildIdExport");
  if (btnAddEle && boxEle) {
    btnAddEle.addEventListener("click", function () {
      if(document.querySelector("input[name=job_status]:checked")) {
        var job_status = document.querySelector("input[name=job_status]:checked").value
        if(job_status == 2) {
          var numCompanyName = $('.addCompany1').length
          let numbers = parseInt(numCompanyName) + 1;
          if(numbers <= 10) {
            $("#numCompanyName").val(numbers);
            const blockChildId = `
              <div class="addCompany1 add">
                <div class="box">
                    <input class="item" placeholder="社名" type="text" name="company_name_corporate[${numbers}]">
                </div>
                <div class="button jsBtnDeleteCompany1"></div>
              </div>
            `;
            boxEle.insertAdjacentHTML("beforeend", blockChildId);
            handleDelFormChildIdExpert();
          } else {
            alert('社名は10社以下で入力してください。');
          }
        }
        const companyEles = boxEle.querySelectorAll('.addCompany1');
        handleUpdateInputNameChildIdExpert(companyEles);
      } else {
        alert('就業状況を入力してください。');
      }
    });
  }
}

function handleDelFormChildIdExpert() {
  const btnDels = document.querySelectorAll(".jsBtnDeleteCompany1");
  if (btnDels) {
    btnDels.forEach((btn) => {
      btn.addEventListener("click", () => {
        var job_status = document.querySelector("input[name=job_status]:checked").value
        if(job_status == 2) {
          btn.closest(".addCompany1").remove();
          let numCompanyName = $('.addCompany1').length;
          let numbers = parseInt(numCompanyName);
          $("#numCompanyName").val(numbers);
        }
        const companyEles = document.querySelectorAll('#jsBoxAddChildIdExport .addCompany1');
        handleUpdateInputNameChildIdExpert(companyEles);
      });
    });
  }
}

function handleAddBlockFDF() {
  const btnAddEle = document.getElementById("jsBtnAddBlockFDF");
  const boxEle = document.getElementById("data_attached_document");
  if (btnAddEle && boxEle) {
    btnAddEle.addEventListener("click", function () {
      let numAttachedDocument = $("#numAttachedDocument").val();
      let numbers = parseInt(numAttachedDocument) + 1;
      let quantity = $("#numAttachedDocument").data('quantity')
      if(numbers <= quantity) {
        for (var i = 1; i <= numbers; i++) {
          $("#numAttachedDocument").val(numbers);
          $("#blockUploadFile"+i).css('display', 'block');
        }
      } else {
        // TODO Add update file
        //handleAddButtonUpdateFile();
        alert('添付ファイルは'+quantity+'つ以内でアップロードしてください。');
      }
    });
  }
}

function handleDelBlockFDF() {
  const btnDels = document.querySelectorAll(".jsBtnDeleteBlockFDF");
  if (btnDels) {
    btnDels.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        let numAttachedDocument = $("#numAttachedDocument").val();
        let numbers = parseInt(numAttachedDocument) - 1;
        $("#numAttachedDocument").val(numbers);
        let ids = btn.getAttribute("value");
        $("#blockUploadFile"+ids).css('display', 'none');
        $("#blockUploadFile"+ids+" .uploadErrorsWrapping").hide();
        $("#originalName"+ids).find('a').first().text('');

        let input = $(btn).parents('.uploadWrapping').attr('data-storeinput')
         $(".uploadWrapping").find('input[name="'+input+'"]').val("");
      });
    });
  }
}

function handleAddBlockFileFDF() {
  const btnAddEle = document.getElementById("jsBtnAddBlockFileFDF");
  const boxEle = document.getElementById("data_file_company");
  if (btnAddEle && boxEle) {
    btnAddEle.addEventListener("click", function () {
      let numAttachedDocument = $("#numFileCompany").val();
      let numbers = parseInt(numAttachedDocument) + 1;
      if(numbers <= 5) {
        $("#numFileCompany").val(numbers);
        for (var i = 1; i <= numbers; i++) {
          $("#blockUploadFilefile"+i).css('display', 'block');
        }
      } else {
        alert('資料添付は5社以下で入力してください。');
      }
    });
  }
}

function handleDelBlockFileFDF() {
  const btnDels = document.querySelectorAll(".jsBtnDeleteBlockFileFDF");
  if (btnDels) {
    btnDels.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        let numFileCompany = $("#numFileCompany").val();
        let numbers = parseInt(numFileCompany) - 1;
        $("#numFileCompany").val(numbers);
        let ids = btn.getAttribute("value");
        $("#blockUploadFilefile"+ids).css('display', 'none');
        $(".uploadWrapping").find('input[name="file_' + ids + '_company"]').val("");
        $("#blockUploadFilefile"+ids+" .uploadErrorsWrapping").hide();
        $("#originalName"+ids).find('a').first().text('');
      });
    });
  }
}

function handlePreferredInputCheck() {
  const inputEle1 = document.getElementById('contact_via3');
  const inputEle2 = document.getElementById('contact_via_name');
  if (inputEle1 && inputEle2) {
    inputEle1.addEventListener('change', () => {
      if(inputEle1.checked){
        inputEle2.classList.remove('hide');
      } else {
        inputEle2.classList.add('hide');
      }
    })
  }
}

function handleDelInputCompany() {
  const btnDels = document.querySelectorAll(".jsBtnDeleteCompany1");
  if (btnDels) {
    btnDels.forEach((btn) => {
      btn.addEventListener("click", () => {
        btn.closest(".addCompany1").remove();
      });
    });
  }
}

function handleAddInputCompany() {
  const btnAddEle = document.getElementById("jsBtnAddCompany1");
  const boxEle = document.getElementById("jsWrapAddCompany1");
  let num = 1;
  if (btnAddEle && boxEle) {
    btnAddEle.addEventListener("click", function () {
      const blockChildId = `
        <div class="addCompany1 add">
          <div class="box">
              <input class="item" id="company_name_${num}" type="text" />
          </div>
          <div class="button jsBtnDeleteCompany1"></div>
        </div>
      `;
      num += 1;
      boxEle.insertAdjacentHTML("beforeend", blockChildId);
      handleDelInputCompany();
    });
  }
}

function handleUpdateInputNamePrefCanWork(elements) {
  if(elements){
    elements.forEach((element, index) => {
      element.querySelector('select').setAttribute('name', `pref_can_work[${index + 1}]`);
    })
  }
}

function handleDelPrefCanWork() {
  const btnDels = document.querySelectorAll(".jsBtnDeletePrefCanWork");
  if (btnDels) {
    btnDels.forEach((btn) => {
      btn.addEventListener("click", () => {
        var area_can_work = document.querySelector('input[name="area_can_work[1]"]:checked').value;
        if(area_can_work == 1) {
          btn.closest(".prefCanWork").remove();
          let numPref = $('.prefCanWork').length;
          let numbers = parseInt(numPref);
          $("#numPref").val(numbers);
        }
        const prefCanWorkList = document.querySelectorAll('#jsBoxAddPrefCanWork .prefCanWork');
        handleUpdateInputNamePrefCanWork(prefCanWorkList);
      });
    });
  }
}

function handleAddPrefCanWork() {
  const btnAddEle = document.getElementById("jsBtnAddPrefCanWork");
  const boxEle = document.getElementById("jsBoxAddPrefCanWork");
  if (btnAddEle && boxEle) {
    btnAddEle.addEventListener("click", function () {
      if(document.querySelector('input[name="area_can_work[1]"]:checked')) {
        var area_can_work = document.querySelector('input[name="area_can_work[1]"]:checked').value
        if(area_can_work == 1) {
          var numPref = $('.prefCanWork').length
          let numbers = parseInt(numPref) + 1;
          if(numbers <= 5) {
            $("#numPref").val(numbers);
            let blockChildId = ``;
            blockChildId += `
              <div class="twoBox3 prefCanWork">
                <div class="blockBox">
                  <select id="pref_can_work${numbers}" name="pref_can_work[${numbers}]">
                    <option value="" selected>都道府県</option>`;
                    Object.keys(disable_pref).forEach(key => {
                      blockChildId += `<option value="${key}">${disable_pref[key]}</option>`;
                    });

                  blockChildId += `</select>
                </div>
                <div class="blockBtn">
                    <span class="btnDelPlus jsBtnDeletePrefCanWork"></span>
                </div>
              </div>
            `;
            boxEle.insertAdjacentHTML("beforeend", blockChildId);
            handleDelPrefCanWork();
          } else {
            alert('都道府県は5社以下で入力してください。');
          }
        }
        const prefCanWorkList = boxEle.querySelectorAll('.prefCanWork');
        handleUpdateInputNamePrefCanWork(prefCanWorkList);
      } else {
        alert('勤務可能な地域を入力してください。');
      }
    });
  }
}

window.addEventListener("load", function () {
  handleAddFormChildId();
  handleDelFormChildId();
  handleAddFormChildIdExpert();
  handleDelFormChildIdExpert();
  handleAddBlockFDF();
  handleDelBlockFDF();
  handleAddBlockFileFDF();
  handleDelBlockFileFDF();
  handlePreferredInputCheck();
  handleAddInputCompany();
  handleAddPrefCanWork();
  handleDelPrefCanWork();
});


function handleAddButtonUpdateFile() {
  const blockChildId = `
    <div id="blockUploadFile99" style="display: block;">
      <div class="avatarBlock uploadWrapping" id="attached_document_1" data-storeinput="attached_document_1">
        <input type="hidden" name="attached_document_1" value="">
        <input type="hidden" name="path_file" value="tmp" class="uploadFilePath">
        <input type="hidden" name="rename" value="storage/experts" class="uploadFileRename">
        <input type="hidden" name="type_file" value="file" class="uploadFileType">
        <div class="box">
            <input type="file" name="file" class="uploadFileInput" style="display: none">
            <p class="sub originalName" id="originalName1"><a target="_blank" href=""></a></p>
            <a href="javascript:void(0)" class="btnFile uploadAddBtn">ファイルを選択</a>
            <p class="sub2">1MB以下の PDFファイルを選択してください。<br>変更は保存するまで反映されません。</p>
            <a href="javascript:void(0)" class="confirm ml10 uploadRemoveBtn" data-alert="本当に削除してもよろしいですか？" style="display:none">
                <i class="fa fa-times" aria-hidden="true"></i>削除する
            </a>
            <p class="uploadErrorsWrapping textError" style="display: none;"></p>
        </div>
        <div class="blockBtn">
          <span class="btnDelPlus jsBtnDeleteBlockFDF"></span>
        </div>
      </div>
    </div>`;
    const boxEle = document.getElementById("data_attached_document");
    boxEle.insertAdjacentHTML("beforeend", blockChildId);
    $(".uploadWrapping").on("click", ".uploadAddBtn", function () {
      $(this).parents(".uploadWrapping").find(".uploadFileInput").click();
      initAjaxFileUpload();
    });
}

// add include function load
function initAjaxFileUpload() {
  $(".uploadWrapping").each(function () {
    var that = $(this);
    that.find(".uploadErrorsWrapping").html("").hide();
    // Initialize the jQuery File Upload plugin
    that.fileupload({
        url: "/expert/upload/file",
        // This element will accept file drag/drop uploading
        dropZone: that,
        // This function is called when a file is added to the queue;
        // either via the browse button, or via drag/drop:
        add: function (e, data) {
            var file = data.files[0];
            var name = file.name;
            var title = file.name
                .beforeLastIndex(".")
                .replace(/_/gi, " ");
            var type = file.type;
            var size = sizeFormat(file.size);
            var extension = getFileExtension(file.name);
            var type_allow = "";
            var add_text = "";

            if (that.find(".uploadFileType").val() === "file") {
                type_allow = conf.file_type_allow;
            } else if (that.find(".uploadFileType").val() === "image") {
                type_allow = conf.image_type_allow;
                add_text = "写真は ";
            } else {
                if (
                    conf.image_type_allow
                        .split(",")
                        .indexOf(extension.toLowerCase()) == 1
                ) {
                    type_allow = conf.image_type_allow;
                    add_text = "写真は ";
                } else if (
                    conf.file_type_allow
                        .split(",")
                        .indexOf(extension.toLowerCase()) == 0
                ) {
                    type_allow = conf.file_type_allow;
                }
            }

            if (
                type_allow &&
                type_allow
                    .split(",")
                    .indexOf(extension.toLowerCase()) == -1
            ) {
                let message_error = 'ファイルをアップロードしてください。';
                if (that.find(".uploadFileType").val() === "file") {
                    message_error = 'ファイルをアップロードしてください。';
                }
                that.find(".uploadErrorsWrapping")
                    .html(
                        add_text +
                            type_allow.toUpperCase() + message_error
                    )
                    .show();
                return;
            }
            if (
                Number((file.size / 1024).toFixed(2)) >=
                conf.file_max_size
            ) {
                let max_size_error = 'MB以下アップロードしてください。';
                if (that.find(".uploadFileType").val() === "file") {
                    max_size_error = 'MB以下アップロードしてください。';
                }
                that.find(".uploadErrorsWrapping")
                    .html(
                        (conf.file_max_size / 1024).toFixed(0) + max_size_error
                    )
                    .show();
                return;
            }

            var formData = {};
            formData._token = $('input[name="_token"]').val();
            // formData.table = $('input[name="table"]').val();
            // formData.resize = $('input[name="resize"]').val();
            formData.path = that.find(".uploadFilePath").val();
            formData.rename = that.find(".uploadFileRename").val();
            data.formData = formData;
            that.find(".uploadPreview").attr(
                "src",
                "/assets/img/loading.gif"
            );
            // Automatically upload the file once it is added to the queue
            var jqXHR = data.submit();
        },
        done: function (e, data) {
            var store_name = that.data("storeinput");

            var input = that.find('input[name="' + store_name + '"]');
            input.val(data.result.path);

            if (that.find(".uploadFileType").val() === "file") {
                that.find(".uploadPreview").attr(
                    "src",
                    "/assets/img/icon_pdf.png"
                );
                var originalName = data.result.path.replace(/temp|project|storage|\//g, "")
                that.find(".originalName").text(
                    originalName
                );

                initNameFiles(store_name, data.result.file)

                //$("#originalName").text(data.result.file);
            } else if (that.find(".uploadFileType").val() === "image") {
                that.find(".uploadPreview").attr(
                    "src",
                    data.result.path
                );
                if (
                    navigator.userAgent.indexOf("MSIE") != -1 ||
                    !!document.documentMode == true
                ) {
                    objectFitIE(".jsObjectFitIE");
                }
            } else {
                var extension = getFileExtension(
                    data.result.original_name
                );
                if (
                    conf.image_type_allow
                        .split(",")
                        .indexOf(extension.toLowerCase()) != -1
                ) {
                    that.find(".uploadPreview").attr(
                        "src",
                        data.result.path
                    );
                    if (
                        navigator.userAgent.indexOf("MSIE") != -1 ||
                        !!document.documentMode == true
                    ) {
                        objectFitIE(".jsObjectFitIE");
                    }
                } else if (
                    conf.file_type_allow
                        .split(",")
                        .indexOf(extension.toLowerCase()) == 0
                ) {
                    that.find(".uploadPreview").attr(
                        "src",
                        "/assets/img/icon_pdf.png"
                    );
                    that.find(".originalName").text(
                        data.result.original_name
                    );
                }
            }
            that.find(".uploadRemoveBtn").css("display", "");
            that.find(".uploadErrorsWrapping").html("");
        },

        fail: function (e, data) {
            var fail = JSON.parse(data.jqXHR.responseText);
            if (fail.errors.file) {
                that.find(".uploadPreview").attr(
                    "src",
                    "/assets/img/img_thumb_pdf.jpg"
                );
                that.find(".originalName").text("");
                that.find(".uploadErrorsWrapping")
                    .html(fail.errors.file)
                    .show();
            }
        },
    });
  });
  // END dropZoneUpload

  // Remove photo
  $(".uploadWrapping").delegate(".uploadRemoveBtn", "click", function () {
    var that = $(this).parents(".uploadWrapping");
    var store_name = that.data("storeinput");
    var input = that.find('input[name="' + store_name + '"]');
    if (input.val()) {
      if (that.find(".uploadFileType").val() === "file") {
          that.find(".uploadPreview").attr(
              "src",
              "/assets/admin/img/admin/img_thumb_pdf.jpg"
          );
          that.find(".originalName").text("");
      } else if (that.find(".uploadFileType").val() === "image") {
          that.find(".uploadPreview").attr(
              "src",
              "/assets/img/expert/profile/icon_default.jpg"
          );
      } else {
          that.find(".uploadPreview").attr(
              "src",
              "/assets/admin/img/admin/img_thumb_pdf.jpg"
          );
          that.find(".originalName").text("");
      }
      input.val("");
    }
    that.find(".uploadErrorsWrapping").html("");
    that.find(".uploadRemoveBtn").css("display", "none");
  });
}
function objectFitIE(className) {
  $(className).each(function () {
      var $el = $(this),
          $img = $el.children("img"),
          src = $img.attr("src");
      if ($el.hasClass("imgContain")) {
          $el.addClass("IE");
      } else {
          $el.addClass("IE").css({
              "background-image": "url(" + src + ")",
          });
          $img.hide();
      }
  });
}
function initNameFiles(value, file) {
  switch(value) {
      case 'attached_document_1':
      case 'attached_document_2':
      case 'attached_document_3':
      case 'attached_document_4':
      case 'attached_document_5':
          let result = value.replace("attached_document_", "");
          $("#originalName"+result).text(file);
          break;
      default:
          $("#originalName").text(file);
          break;
  }
}

function sizeFormat(bytes) {
    if (typeof bytes !== "number") {
        return "";
    }
    if (bytes >= 1000000000) {
        return (bytes / 1000000000).toFixed(2) + " GB";
    }
    if (bytes >= 1000000) {
        return (bytes / 1000000).toFixed(2) + " MB";
    }
    return (bytes / 1000).toFixed(2) + " KB";
}

function getFileExtension(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
}

// end include function load

var disable_pref = {
'1'  : '北海道',
'2'  : '青森県',
'3'  : '岩手県',
'4'  : '宮城県',
'5'  : '秋田県',
'6'  : '山形県',
'7'  : ' 福島県',
'8'  : '茨城県',
'9'  : '栃木県',
'10' : '群馬県',
'11' : '埼玉県',
'12' : '千葉県',
'13' : '東京都',
'14' : '神奈川県',
'15' : '新潟県',
'16' : '富山県',
'17' : '石川県',
'18' : '福井県',
'19' : '山梨県',
'20' : '長野県',
'21' : '岐阜県',
'22' : '静岡県',
'23' : '愛知県',
'24' : '三重県',
'25' : '滋賀県',
'26' : '京都府',
'27' : '大阪府',
'28' : '兵庫県',
'29' : '奈良県',
'30' : '和歌山県',
'31' : '鳥取県',
'32' : '島根県',
'33' : '岡山県',
'34' : '広島県',
'35' : '山口県',
'36' : '徳島県',
'37' : '香川県',
'38' : '愛媛県',
'39' : '高知県',
'40' : '福岡県',
'41' : '佐賀県',
'42' : '長崎県',
'43' : '熊本県',
'44' : '大分県',
'45' : '宮崎県',
'46' : '鹿児島県',
'47' : '沖縄県',
}
